const autoNgTemplateLoaderTemplate1 = require('./tasksDatatable.html');

angular.module('portainer.docker').component('tasksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'TasksDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    nodes: '<',
    showSlotColumn: '<',
    showLogsButton: '<',
    agentProxy: '<',
  },
});
